// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;
